import { getViemClient, } from "@bracket/contractor-next";

import type { Config, } from "wagmi";
import type { ValidChainId, } from "@bracket/chainography";
import type { EpochSeconds, } from "@bracket/types";



export declare type GetChainTime = {
	config?: Config;
	chainId?: ValidChainId;
	interval?: number;
}

export declare type OnChainTimeChangeHandler = ( seconds?: EpochSeconds, ) => void | Promise<void>;

const cachedBlockTime = {
	time: 0,
	since: 0,
	set: false,
	fetching: false,
}

const listeners = new Set<OnChainTimeChangeHandler>();


/**
 * Get the current chain time in unix epoch MILLISECONDS
 * @param param0 
 * @returns {number} current time in miliseconds since 1/1/1970
 */
export const getChainTime = async ({
	config,
	chainId = 1,
	interval = 15_000,
}: GetChainTime = {}): Promise<number> => {

	const now = Date.now();
	const { set, fetching, time, since,} = cachedBlockTime;
	if(!set) {
		if(!fetching) {
			cachedBlockTime.fetching = true;
			const client = getViemClient({ config, chainId, });
			const block = await client.getBlock();
			cachedBlockTime.time = Number(block.timestamp) * 1000;
			cachedBlockTime.fetching = false;
			cachedBlockTime.set = true;
			cachedBlockTime.since = now;
			dispatchChainTimeChange(cachedBlockTime.time);
			const { since, time, } = cachedBlockTime;
			return time + ( now - since );
		}
		const time = await awaitChainTimeSet();
		return time + ( Date.now() - cachedBlockTime.since );
	}
	return time + ( now - since );
}

const awaitChainTimeSet = (): Promise<number> => {
	return new Promise((resolve, reject) => {

		const to = setTimeout(() => {
			reject(new Error("Chain time not set after 5 seconds"));
			clearTimeout(to);
			clearInterval(inte);
		}, 5000);

		const inte = setInterval(() => {
			const { set, fetching, } = cachedBlockTime;
			if(set && !fetching) {
				resolve(cachedBlockTime.time);
				clearInterval(inte);
				clearTimeout(to);
			}
		}, 25);

	});
}

const dispatchChainTimeChange = ( seconds: EpochSeconds, ) => {
	for(const listener of listeners) {
		listener(seconds);
	}
}

export const onChainTimeChange = ( fn: OnChainTimeChangeHandler, ): void => {
	if(!listeners.has(fn)) {
		listeners.add(fn);
		return;
	}
}

export const removeChainTimeChangeListener = ( fn: OnChainTimeChangeHandler, ): void => {
	listeners.delete(fn);
}
